import styled from 'styled-components'

export const Marginer = styled.div`
    ${({ top = 0, right = 0, bottom = 0, left = 0 }) => `
    margin: ${top}px ${right}px ${bottom}px ${left}px;
`}
`



// WEBPACK FOOTER //
// ./src/components/Util/index.js